module.exports = __webpack_public_path__ + "static/img/menno.3c197be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/nilfgaardian/menno.png
// module id = qDDz
// module chunks = 0